import { SYS } from "@/common/schema/system";
import type { ImpersonateUser } from "@/common/schema/commands/System/ImpersonateUser";

const stop        = (): ImpersonateUser                   => ({ impersonating: undefined });
const impersonate = (target: SYS.UserId): ImpersonateUser => ({ impersonating: target    });

export function impersonateCommandFor(
  targetUserId: SYS.UserId | undefined,
  superUserId:  SYS.UserId,
): ImpersonateUser {
  const isStopImpersonation = targetUserId === undefined;
  if (isStopImpersonation) return stop();

  const isSelfImpersonation = targetUserId.asStr === superUserId.asStr;
  if (isSelfImpersonation) return stop();

  return impersonate(targetUserId);
}
